<template lang="html">
  <div class="main h-100">

    <div class="ui centered grid">
      <div v-show="showConfirmation" class="seven wide computer sixteen wide mobile column">
        <div class="ui icon info message">
          <i class="check icon"></i>
          <div class="content">
            <div class="header">
              Cartão de Crédito adicionado
            </div>
            <p>Cartão de Crédito adicionado com sucesso. Obrigado.</p>
          </div>
        </div>
      </div>
      <div v-show="!showConfirmation" class="seven wide computer sixteen wide mobile column">
        <div v-show="loading" class="ui active inverted dimmer">
          <div class="ui text loader">Buscando ...</div>
        </div>
        <h1 class="ui header">Olá, {{contract.owner_name}}</h1>
        <p>Para confirmar a contratação do seu plano, entre com os dados do seu cartão de crédito:</p>
        <div class="ui info message">
          <p>Você está contrando o plano <b>{{contract.plan_name}}</b> no valor mensal de <b>{{contract.monthly_value}}</b></p>
        </div>
        <form
          @submit.prevent="save" class="ui form"
          v-autocomplete-off
        >
          <div class="field">
            <label for="credit-card-holder-name">Título do Cartão</label>
            <input
              type="text"
              id="credit-card-holder-name"
              v-model="form.card_holder_name"
            />
          </div>
          <div class="fields">
            <div class="eleven wide field">
              <label for="credit-card-number">Número</label>
              <input
                type="text"
                id="credit-card-number"
                v-model="form.card_number"
              />
            </div>
            <div class="three wide field">
              <label for="credit-card-expiration"
                >Validade</label
              >
              <input
                type="text"
                placeholder="MM/YY"
                id="credit-card-expiration"
                v-mask="'##/##'"
                v-model="form.card_expiration"
              />
            </div>
            <div class="two wide field">
              <label for="credit-card-cvv">CVV</label>
              <input
                type="text"
                id="credit-card-cvv"
                v-model="form.card_cvv"
              />
            </div>
          </div>
          <div class="right field">
            <button
              type="submit"
              name="save"
              class="ui submit blue fluid button"
            >
              Adicionar Cartão de Crédito
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
  import Api from '@/resources/Api'
  export default {
    name: 'credit_card',

    data () {
      return {
        loading: false,
        showConfirmation: false,
        contract: {},
        form: {}
      }
    },

    mounted() {
      this.fetch();
    },

    methods: {
      fetch() {
        this.loading = true;
        Api.contracts
          .fetch(this.$route.params.contract)
          .then(async response => {
            this.contract = response.data.contract
          })
          .catch(error => {
            if (error.response) {
              this.$toast.show('Erro ao buscar contrato', 'error');
            } else {
              throw error;
            }
          })
          .finally(() => {
            this.$scrollTop();
            this.loading = false;
          });
      },

      save() {
        this.loading = true;
        let payment_method = this.form;

        payment_method.card_expiration_month = payment_method
          .card_expiration
          ? payment_method.card_expiration.split('/')[0]
          : '';

        payment_method.card_expiration_year = payment_method
          .card_expiration
          ? payment_method.card_expiration.split('/')[1]
          : '';

        payment_method.new_card = true;
        payment_method.id = this.contract.payment_method.id;

        const data = {
          id: this.$route.params.contract,
          payment_method_attributes: payment_method
        }

        Api.contracts
          .save(data)
          .then(async response => {
            this.showConfirmation = true
          })
          .catch(error => {
            if (error.response) {
              this.$toast.show('Erro ao salvar cartão', 'error');
            } else {
              throw error;
            }
          })
          .finally(() => {
            this.$scrollTop();
            this.loading = false;
          });
      },
    }
  }
</script>

<style lang="css" scoped>
  .main {
    background: white;
  }
  .centered.grid {
    padding-top: 30px;
    font-size: 18px;
    color: rgba(0,0,0,.6)
  }
</style>
